import { render, staticRenderFns } from "./vinReqRecord.vue?vue&type=template&id=29bfcc57&scoped=true&"
import script from "./vinReqRecord.vue?vue&type=script&lang=js&"
export * from "./vinReqRecord.vue?vue&type=script&lang=js&"
import style0 from "./vinReqRecord.vue?vue&type=style&index=0&lang=less&"
import style1 from "./vinReqRecord.vue?vue&type=style&index=1&id=29bfcc57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bfcc57",
  null
  
)

component.options.__file = "vinReqRecord.vue"
export default component.exports